<template>
    <div>
        <h5 class="mt-1 mb-3">{{ $t('hr_information').toUpper() }}</h5>
        <b-row>
            <b-col cols="12" lg="12">
                <b-card :header="$t('hr_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('employee_id') }}</label>
                                <div>{{ staffInformation.employee_id || '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('supervisor') }}</label>
                                <div>{{ staffInformation.supervisor_name || '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('hr_budgetary_department') }}</label>
                                <div>{{ staffInformation.budgetary_department_name || '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('job_title') }}</label>
                                <div>{{ staffInformation.job_title_name || '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('leadership_team') }}</label>
                                <div>{{ staffInformation.is_leadership_team ? $t('yes') : $t('no') }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('purchase_officer') }}</label>
                                <div>{{ staffInformation.is_purchase_officer ? $t('yes') : $t('no') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <b-button variant="primary"
                          @click="updateFormShow"
                          v-if="checkPermission('staff_update')">
                    {{ $t('edit') }}
                </b-button>
            </b-col>
        </b-row>
        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('staff_update')">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :staff-information="staffInformation"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess === 'update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
import UpdateForm from './UpdateForm.vue';

export default {
    components: { UpdateForm },
    props: {
        staffInformation: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            formProcess: null
        }
    },
    methods: {
        clearFormData() {
            this.formProcess = null;
        },
        updateFormShow() {
            this.formProcess = 'update';
            this.$refs.formModal.$refs.commonModal.show();
        },
        updateFormSuccess() {
            this.clearFormData();
            this.$refs.formModal.$refs.commonModal.hide();
            this.$emit('updatedData', true);
        }
    }
}
</script>
